/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserList} from '../models/UserList';

export interface GetUsersByAccountId$Request {
    accountId: number;
}

export interface GetUsersByAccountId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersByAccountIdRequest = createAction<PayloadData<void, GetUsersByAccountId$Request>>('USER_CONTROLLER__GET_USERS_BY_ACCOUNT_ID__REQUEST');
export const getUsersByAccountIdSuccess = createAction<PayloadData<UserList, GetUsersByAccountId$Request>>('USER_CONTROLLER__GET_USERS_BY_ACCOUNT_ID__SUCCESS');
export const getUsersByAccountIdFailure = createAction<PayloadData<Error, GetUsersByAccountId$Request, true>>('USER_CONTROLLER__GET_USERS_BY_ACCOUNT_ID__FAILURE');

export const getUsersByAccountIdActions = [
    getUsersByAccountIdRequest,
    getUsersByAccountIdSuccess,
    getUsersByAccountIdFailure
] as const;

/**
 * @param {number} meta.accountId Id of account
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersByAccountId = (meta: GetUsersByAccountId$Request, config?: GetUsersByAccountId$Config) => {
    return {
        CALL_API: {
            types: getUsersByAccountIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/users`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

